<template>
  <div class="cm-content">
    <div class="title">
      <img src="@/assets/圆圈.png" />
      <div>赢销心意</div>
    </div>
    <el-row class="row row-dark">
      <el-col :span="24">
        <div>
          <div class="key">营销商品：</div>
          <div class="value">{{bean.commodityName}}</div>
        </div>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col :span="24">
        <div>
          <div class="key">营销说明：</div>
          <div class="value">{{bean.marketingInstructions}}</div>
        </div>
      </el-col>
    </el-row>

    <!-- <div class="null" v-if="images.length < 1">
      <div>暂无内容！</div>
      <img src="@/assets/暂无内容.png" alt />
    </div>-->

    <div class="images" v-if="images.length > 0">
      <Prev class="arrow arrow-left" @click="onPrev" v-if="images.length > 8" />
      <a
        data-fancybox="gallery"
        class="image"
        v-for="(item, index) in images.slice(start, start + 8)"
        :href="util.getImageUrl(item.url, '1000-')"
        :key="index"
        :style="index % 8 != 7 ? 'margin-right: 20px;' : ''"
      >
        <img :src="util.getImageUrl(item.url, '120x120')" />
        <div>{{item.name}}</div>
      </a>
      <Next class="arrow arrow-right" @click="onNext" v-if="images.length > 8" />
    </div>
  </div>
</template>

<script>
import Prev from "@/components/index/Prev";
import Next from "@/components/index/Next";

export default {
  name: "CommodityMarketingContent",
  props: ["bean"],
  components: {
    Prev,
    Next
  },
  computed: {
    images() {
      let result = this.$store.state.marketing.commodityMarketingImage.retrieve.results
        .map(item => {
          return item.url.split(",").map(url => {
            return {
              name: item.name,
              url: url
            };
          });
        })
        .flat();

      return result;
    }
  },
  data() {
    return {
      start: 0
    };
  },
  methods: {
    onPrev() {
      if (this.start > 0) {
        this.start -= 1;
      }
    },
    onNext() {
      if (this.start < this.images.length - 1) {
        this.start += 1;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.cm-content {
  width: 1100px;

  .title {
    margin: 20px 0;

    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .row {
    line-height: 20px;
    min-height: 50px;
    padding: 15px 20px;
  }

  .row-dark {
    background: #f7faf8;
  }

  .key {
    display: inline-block;
    width: 100px;
    color: #666;
    vertical-align: top;
  }
  .value {
    display: inline-block;
    max-width: 960px;
    color: #333;
    line-height: 20px;
  }

  .null {
    text-align: center;
    margin: 25px 0;
    img {
      width: 200px;
    }
  }

  .images {
    position: relative;
    width: 1100px;
    height: 150px;
    margin-top: 20px;
    // overflow-x: visible;
    // overflow-y: hidden;
    // white-space: nowrap;
    // height: 150px;
    // overflow: hidden;
    a {
      text-decoration: none;
    }
    .prev,
    .next {
      z-index: 999;
    }

    .prev {
      //   float: left;
      position: absolute;
      left: -20px;
      top: 40px;
    }

    .next {
      //   float: right;
      position: absolute;
      right: -20px;
      top: 40px;
    }
    .image {
      display: inline-block;
      width: 120px;

      img {
        width: 100%;
        border-radius: 10px;
      }

      div {
        text-align: center;
        height: 20px;
        font-size: 14px;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
      }
    }
  }
}
</style>

